import { useCallback } from 'react';

import { useForm } from 'react-final-form';

import type { FormValues } from '#src/app/pages/petitionDetails/shared/types';

export function useSignFormFieldMutator<FIELD extends keyof FormValues>(
	field: FIELD,
): (value: FormValues[FIELD]) => void {
	const form = useForm();

	return useCallback(
		(value) => {
			form.mutators.setValue(field, value);
		},
		[form, field],
	);
}
